// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"237":"SociosForm","312":"SociosLista"}[chunkId] + ".js";
};